//RecordEditRemoveSelectTypeDialog
//***********************************************************************************************************************
import * as React from "react";
import { Dialog } from "../../framework/Dialog/Dialog";
import { Translations } from "ui/Scripts/source/models/translations";
import { RecordUserRemoveType } from "ui/Scripts/source/models/enums";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { FormControlLabel, Grid, Radio } from "@mui/material";

//RecordEditRemoveSelectTypeDialog
export interface IRecordEditRemoveSelectTypeDialogProps {
    classes?: string;
    onOk: (removeType: RecordUserRemoveType) => void;
    onCancel: () => void;
}

export interface IRecordEditRemoveSelectTypeDialogState {
    removeType: RecordUserRemoveType;
}

export class RecordEditRemoveSelectTypeDialog extends React.Component<IRecordEditRemoveSelectTypeDialogProps, IRecordEditRemoveSelectTypeDialogState> {
    constructor(props: IRecordEditRemoveSelectTypeDialogProps) {
        super(props);
        this.state = {
            removeType: RecordUserRemoveType.RemoveRecordUser
        };
    }

    handleChange = (checked: boolean, removeType: RecordUserRemoveType) => {
        if (!checked) return;
        this.setState({
            removeType
        });
    };

    handleCancel = () => {
        this.props.onCancel();
    };

    handleOk = async () => {
        const state = this.state;
        this.props.onOk(state.removeType);
    };

    render() {
        const state = this.state;
        return (
            <Dialog
                id="recordEditRemoveSelectTypeDialog"
                title={Translations.SelectRemovingMethod}
                body={
                    <>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormControlLabel
                                    label={Translations.RemoveRecordUserAndKeepUser}
                                    control={
                                        <Radio
                                            checked={state.removeType === RecordUserRemoveType.RemoveRecordUser}
                                            onChange={(_e, checked: boolean) => {
                                                this.handleChange(checked, RecordUserRemoveType.RemoveRecordUser);
                                            }}
                                        />
                                    }
                                />
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormControlLabel
                                    label={Translations.RemoveRecordUserAndUserSetExpired}
                                    control={
                                        <Radio
                                            checked={state.removeType === RecordUserRemoveType.RemoveRecordUserAndUserExpired}
                                            onChange={(_e, checked: boolean) => {
                                                this.handleChange(checked, RecordUserRemoveType.RemoveRecordUserAndUserExpired);
                                            }}
                                        />
                                    }
                                />
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormControlLabel
                                    label={Translations.RemoveRecordUserAndUser}
                                    control={
                                        <Radio
                                            checked={state.removeType === RecordUserRemoveType.RemoveRecordUserAndUser}
                                            onChange={(_e, checked: boolean) => {
                                                this.handleChange(checked, RecordUserRemoveType.RemoveRecordUserAndUser);
                                            }}
                                        />
                                    }
                                />
                            </Grid>
                        </GridRow>
                    </>
                }
                buttons={[
                    { title: Translations.OK, variant: "confirmation", onClick: this.handleOk },
                    { title: Translations.Cancel, variant: "outlined", onClick: this.handleCancel },
                ]}
                onClose={this.handleCancel}
            />
        );
    }
}